import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

type Props = {
  subtitle?: string;
  to?: string;
  className?: string;
};

export function BrandMark({ subtitle = "Lab", to = "/", className }: Props) {
  return (
    <Link
      to={to}
      className={cn(
        "group inline-flex items-center gap-2.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md",
        className
      )}
    >
      <span
        aria-hidden
        className="inline-block h-2.5 w-2.5 rounded-full bg-brand shadow-glow transition-transform group-hover:scale-110"
      />
      <span className="font-display text-lg font-bold tracking-tight">
        imgwala{" "}
        <span className="font-medium text-muted-foreground">{subtitle}</span>
      </span>
    </Link>
  );
}
